var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stateStatistics"},[_c('a-tabs',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"实时统计"}},[(_vm.active == '1')?_c('router-view'):_vm._e()],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"历史统计"}},[(_vm.active == '2')?_c('router-view'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }